export const size = {
  button: {
    lg: 56,
    sm: 40,
  },
  "bottom-nav": {
    height: 64,
  },
  input: {
    lg: 64,
  },
  "action-bar": {
    expanded: 120,
  },
  avatar: {
    lg: 64,
    md: 40,
    sm: 32,
  },
  control: {
    md: 48,
    multiline: 96,
    play: 28,
    sm: 32,
  },
  icon: {
    "2xs": 14,
    lg: 32,
    md: 24,
    sm: 20,
    xl: 40,
    xs: 16,
  },
  indicator: {
    dot: {
      lg: 12,
      md: 8,
      sm: 6,
    },
    "drawer-handle": {
      thickness: 4,
      width: 40,
    },
    pagination: {
      "active-width": 24,
      dot: 8,
    },
    "progress-bar": {
      thickness: 8,
    },
    "progress-button": {
      inner: 64,
      outer: 80,
    },
    skeleton: {
      thick: 8,
      thin: 4,
    },
    switch: {
      thumb: 22,
      "track-height": 28,
      "track-width": 48,
    },
    timeline: {
      "done-glyph": 10,
      inner: 8,
      step: 24,
      "step-minimum": 56,
    },
  },
  header: {
    height: 60,
  },
  "selection-control": 24,
  row: {
    lg: 72,
    md: 56,
    sm: 48,
  },
  table: {
    column: 120,
  },
  tooltip: {
    "max-width": 240,
  },
  "touch-target": 44,
} as const;

export type Size = typeof size;
